import { render, staticRenderFns } from "./DetalhesLDI.vue?vue&type=template&id=b7a11a7e"
import script from "./DetalhesLDI.vue?vue&type=script&lang=ts"
export * from "./DetalhesLDI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports